import React from 'react'
const host = process.env.REACT_APP_API_SERVER
const VideoModal = (video) => {

    return (
        <div>
            {/* video popup */}
            <div
                className="modal fade"
                id="videoModal"
                tabIndex={-1}
                aria-labelledby="videoModalLabel"
                aria-hidden="true"
                data-bs-backdrop="static"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="videoModalLabel">
                                Notes Video
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="ratio ratio-16x9">
                               
                                 <video
                                    className="d-none d-md-block d-lg-block d-xl-block img-fluid w-100"
                                    src={`${host}${video}`}
                                    
                                    controls
                                    playsInline
                                    loading="eager"
                                >
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VideoModal